import React, { useEffect } from 'react';
import "../styles/events.css";
import { FaChevronDown } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { getAllEvents } from '../features/events/eventsSlice';
import EventsLoader from '../components/EventsLoader';
import { useNavigate } from 'react-router-dom';
import Meta from '../components/Meta';
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
 import loader from "../images/loader/loader1.jpg";

const formatDateTime = (dateStr, timeStr) => {
  const date = new Date(dateStr);
  const options = { year: 'numeric', month: 'short', day: 'numeric' };
  const dateFormatted = date.toLocaleDateString('en-US', options);
  const timeFormatted = timeStr ? new Date(`1970-01-01T${timeStr}`).toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
  }) : '';
  return `${dateFormatted}${timeStr ? ` @ ${timeFormatted}` : ''}`;
};

const formatFullRange = (startDate, startTime, endDate, endTime) => {
  if (startDate === endDate) {
    return formatDateTime(startDate, startTime);
  } else {
    return `${formatDateTime(startDate, startTime)} – ${formatDateTime(endDate, endTime)}`;
  }
};

const Events = () => {
  const dispatch = useDispatch();
  const eventsState = useSelector((state) => state.event.events);
const navigate = useNavigate();
  useEffect(() => {
    dispatch(getAllEvents());
  }, [dispatch]);

  const handleEvent = (id) => {
   navigate(`/event/${id}`);
  };

  return (
    <>
    <Meta title="Events"/>
       <div>
      <div className="events-header">
        <h3>Upcoming Events</h3>
        <FaChevronDown className="down-icon" />
      </div>
      <div className="events-container">
        {eventsState && eventsState.length > 0 ? (
          eventsState.map((event) => (
            <div key={event._id} className="event-card">
              <div className="event-info">
                <p className="event-date">
                  <span role="img" aria-label="calendar">📅</span>{" "}
                  {formatFullRange(event.startDate, event.startTime, event.endDate, event.endTime)}
                </p>
                <h2 className="event-title">{event.title}</h2>
                <p className="event-location">{event.venue}, {event.city}, Kenya</p>
                <p className="event-description" dangerouslySetInnerHTML={{ __html: event.description }} />
                <div className="event-footer">
                  <button onClick={() => handleEvent(event._id)} className="ticket-btn">Book Now</button>
                  <span className="event-price">KES {event.price?.toLocaleString()}</span>
                </div>
              </div>
              <div className="event-image">
              <LazyLoadImage
                alt='Qentrain Solutions'
                effect="blur"
                src={event.images?.[0]?.url || loader}
                placeholderSrc={loader}
                width="280px"
                height="100%"
                className="img-fluid mx-auto img-el"
              /> 
           
              </div>
            </div>
          ))
        ) : (
          <EventsLoader/>
        )}
      </div>
    </div> 
    </>

  );
};

export default Events;
